import React from "react";
import "../css/Accordion.css";

function Aturan(){
  return ( 
    <section id="terms" class="aturan">
      <div class="aturan_data">
    
           <div className="d-flex justify-content-center titleterm mb-3"> Reservasi Sekarang</div>
              <table class="terms mb-3">
                  <tr>
                    <th >-</th> <th>Harga termasuk : BBM, Driver</th>
                  </tr>
                  <tr>
                    <th >-</th> <th>Dapat singgah di beberapa tempat dalam satu rute kecuali Drop in/off</th> 
                  </tr>
                  <tr>
                    <th >-</th> <th>Biaya tol, parkir, tiket wisata, tiket penyebrangan dan tiket lainnya ditanggung penyewa</th> 
                  </tr>
                  <tr>
                    <th >-</th> <th>Tips untuk driver menjadi kebijakan penyewa</th> 
                  </tr>
                  <tr>
                    <th >-</th> <th>Pemakaian di luar tujuan tidak dalam satu rute dikenakan biaya tambahan BBM</th> 
                  </tr>
                  <tr>
                    <th >-</th> <th>Pelunasan maksimal H-3 keberangkatan. Perubahan maksimal H-7 Trip</th>                    
                  </tr>
                  <tr>
                    <th >-</th> <th>Full Day terhitung 12 Jam</th> 
                  </tr>
                  <tr>
                    <th >-</th> <th>Reservasi dan konfirmasi pembayaran : +62 817 707 10004</th> 
                  </tr>
                  <tr>
                    <th>-</th> <th>Pembayaran Melalui :</th> 
                  </tr>
                  <tr>
                    <th ></th> <th>Bank Central Asia (BCA)</th> 
                  </tr>
                  <tr>
                    <th ></th> <th>PT.CAKRA BUANA UNGGUL</th>
                  </tr>
                  <tr>
                    <th ></th> <th>No. Rek. 345-5555-111</th>
                  </tr>
                  <tr>
                    <th> </th> <th>(harga dapat berubah sewaktu waktu dengan atau tanpa pemberitahuan lebih lanjut)</th>
                  </tr>
              </table>           
            <div class="mb-3">

            </div>
      </div>
  </section>
  );
}


export default Aturan;